export enum ErrorMessages {
  INVALID_CREDENTIALS = 'The email and password do not match. Please check again.',
  NETWORK_ERROR = 'There is a network issue. Please try again later.',
  LOGOUT_ERROR = 'An error occured when trying to logout. Please try again.',
  ACCOUNT_UPDATE_ERROR = 'There was an error updating your account.',
  PERMISSION_REQUIRED = 'Permission required',
  PERMISSIONS_REQUIRED = 'Permissions required',
  INVALID_SESSION = 'Please login again.',
  SERVER_ERROR = 'Something went wrong, please try again',
  FILE_IMAGE_SIZE_LIMIT = 'File size exceeds the 2MB limit',
  FILE_IMAGE_FORMAT = 'Only JPG/JPEG, PNG files are allowed',

  // Fields
  INVALID_EMAIL = 'Invalid email',
  REQUIRED_EMAIL = 'Email is required',
  REQUIRED_PASSWORD = 'Password is required',
  NO_WHITESPACE_PASSWORD = 'Password must not have whitespace',
  REQUIRED_USERNAME = 'Username is required',
  REQUIRED_FIRSTNAME = 'First Name is required',
  REQUIRED_LASTNAME = 'Last Name is required',
  REQUIRED_COUNTRY = 'Country is required',
  REQUIRED_CITY = 'City is required',
  REQUIRED_SHORT_BIO = 'Short Bio is required',
  REQUIRED_ROLE = 'Role is required',
  INVALID_ROLE_LENGTH = 'User must have a minimum of 1 role',
  INVALID_PASSWORD_LENGTH = 'Password must be of minimum 8 characters in length',
  INVALID_NEW_PASSWORD_LENGTH = 'New Password must be of minimum 8 characters in length',
  REQUIRED_CATEGORY_NAME = 'Category Name is required',
  REQUIRED_PHOTO = 'Photo is required',
  REQUIRED_SUBCATEGORY_TITLE = 'Sub Category Title is required',
  INVALID_SUBCATEGORY_LENGTH = 'Sub Category length exceeds the maximum limit of 30 characters',
  REQUIRED_TOPIC_TITLE = 'Topic Title is required',
  REQUIRED_TOPIC_CATEGORY = 'Category Title is required',
  REQUIRED_TOPIC_SUB_CATEGORY = 'Sub Category Title is required',
  INVALID_TOPIC_LENGTH = 'Topic length exceeds the maximum limit of 30 characters',
  REQUIRED_MEDIA_IMAGE = 'Media Image is required',

  // Announcements
  REQUIRED_ANNOUNCEMENT_TITLE = 'Announcement Title is required',

  // Advertisements
  REQUIRED_ADVERTISEMENT_TITLE = 'Advertisement Title is required',
}

export enum AlertTitles {
  ACCOUNT_UPDATED = 'Account Updated',
  UNKOWN_ERROR = 'An error occured',
  INVALID_LOGIN = 'Invalid Login',
  CONFIRM_LOGOUT = 'Log Out',
  SUCCESS = 'Success',
  RESET_DETAILS_FAILED = 'Reset details failed',
  RESET_PASSWORD_FAILED = 'Reset password failed.',
  ACCOUNT_UPDATE_ERROR = 'Account Update Error',
  PERMISSIONS_ERROR = 'Permissions error',
}

export enum AlertMessages {
  LOGOUT = 'Are you sure you want to log out?',
}

export enum AlertButtons {
  LOGOUT_CONFIRM = 'Log Out',
}

export enum SuccessMessages {
  ACCOUNT_UPDATED_SUCCEEDED = 'Your account has been updated.',
  SUCCESS_APPROVED_TOPIC = 'Success approved topic.',
  SUCCESS_DISAPPROVED_TOPIC = 'Success disapproved topic.',
}

export enum ResetPasswordStrings {
  RESET_PASSWORD_TITLE = 'Set your New Password',
  RESET_PASSWORD_DESCRIPTION = 'Enter details below to set a new password',
  RESET_PASSWORD_NEW_PASSWORD_LABEL = 'New Password',
  RESET_PASSWORD_CONFIRM_PASSWORD_LABEL = 'Confirm Password',
  RESET_PASSWORD_NEW_PASSWORD_ERROR_MESSAGE = 'New Password is required',
  RESET_PASSWORD_CONFIRM_PASSWORD_ERROR_MESSAGE = 'Confirm Password is required',
  RESET_PASSWORD_DOES_NOT_MATCH_ERROR_MESSAGE = "Password doesn't match",
}

export enum ButtonStrings {
  BUTTON_CONFIRM = 'Confirm',
}

export const REGEX_WHITESPACE = /^\S+$/;
